import { EndpointRequestInit as EndpointRequestInit_1 } from "@hilla/frontend";
import client_1 from "./connect-client.default.js";
import type TenantStyle_1 from "./oxynoia/documents/collection/b2c/model/TenantStyle.js";
async function getStyle_1(tenantId: string | undefined, init?: EndpointRequestInit_1): Promise<TenantStyle_1 | undefined> { return client_1.call("TenantStyleEndpoint", "getStyle", { tenantId }, init); }
export { getStyle_1 as getStyle };
